import { Routes, Route } from 'react-router-dom';
import { CartProvider } from './context/CartContext';
import { ChatBotProvider } from './context/ChatBotContext';
import { AuthProvider } from './context/AuthContext';
import Header from './components/Header';
import Footer from './components/Footer';
import HomePage from './pages/HomePage';
import ShopPage from './pages/ShopPage';
import AboutPage from './pages/AboutPage';
import ContactPage from './pages/ContactPage';
import CartPage from './pages/CartPage';
import LookbookPage from './pages/LookbookPage';
import CustomJewelryPage from './pages/CustomJewelryPage';
import LoginPage from './pages/LoginPage';
import AccountPage from './pages/AccountPage';
import AdminDashboard from './pages/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import { ChatBot } from './components/ChatBot';

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <ChatBotProvider>
          <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-grow">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/shop" element={<ShopPage />} />
                <Route path="/about" element={<AboutPage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/cart" element={<CartPage />} />
                <Route path="/lookbook" element={<LookbookPage />} />
                <Route path="/custom-jewelry" element={<CustomJewelryPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route
                  path="/account"
                  element={
                    <ProtectedRoute>
                      <AccountPage />
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/admin"
                  element={
                    <ProtectedRoute requireAdmin>
                      <AdminDashboard />
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </main>
            <Footer />
            <ChatBot />
          </div>
        </ChatBotProvider>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
 